import React from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileNav from './MobileNav';
import WebsiteLockPopup from '../WebsiteLockPopup';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const showMobileNav = !location.pathname.includes('/confirmation');

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <WebsiteLockPopup />
      <main className="flex-grow">
        {children}
      </main>
      <Footer className="hidden md:block" />
      {showMobileNav && <MobileNav />}
    </div>
  );
};

export default Layout;